export enum VendorType {
    UNSPECIFIED = 'unspecified',
    FINANCING_COMPANY = 'financing-company',
    INSURANCE_COMPANY = 'insurance-company',
    MAINTENANCE_COMPANY = 'maintenance-company',
    IMPORTER = 'importer',
    TIRE_STORAGE_COMPANY = 'tire-storage-company',
    VEHICLE_DEALERSHIP = 'vehicle-dealership',
    FUEL_COMPANY = 'fuel-company',
    ELECTRICAL_CHARGING_COMPANY = 'electrical-charging-company',
    CAR_RENTAL_COMPANY = 'car-rental-company',
    VEHICLE_TRACKING_COMPANY = 'vehicle-tracking-company',
    VEHICLE_TAXATION_AUTHORITY = 'vehicle-taxation_authority',
    CAR_WASH_COMPANY = 'car-wash-company',
    TIRE_COMPANY = 'tire-company',
    INSPECTION_COMPANY = 'inspection-company',
    PARKING = 'parking',
}
